import { useMemo, useState } from 'react';

export type SetFunctions<T> = {
    add: (...value: T[]) => void;
    toggle: (...values: T[]) => void;
    remove: (...values: T[]) => void;
    set: React.Dispatch<React.SetStateAction<Set<T> | T[]>>;
};
export function useSet<T>(initial: () => Set<T>): [Set<T>, SetFunctions<T>] {
    const [storedSet, setStoredSet] = useState(initial);

    const functions = useMemo<SetFunctions<T>>(
        () => ({
            add: (...values) => setStoredSet((cur) => cur.union(new Set(values))),
            toggle: (...values) =>
                setStoredSet((cur) => cur.symmetricDifference(new Set(values))),
            remove: (...values) => setStoredSet((cur) => cur.difference(new Set(values))),
            set: (valuesOrFn) => {
                setStoredSet((cur) => {
                    const values =
                        typeof valuesOrFn === 'function' ? valuesOrFn(cur) : valuesOrFn;
                    return Array.isArray(values) ? new Set(values) : values;
                });
            },
        }),
        [],
    );

    return [storedSet, functions];
}
